import type { VoidFunctionComponent } from 'react';
import { useCanDisplaySecurityOptions } from '../../generic/hooks';
import Subnav from '../../../generic/Subnav';
import { ReportCategories, ReportCategoryTitles } from '../../generic/ReportGeneration/utils';
import { isFreeTier } from '../../../../../shared/subscriptions';
import { window } from '../../../../globals';
import { useIsFeatureEnabled } from '../../../../helpers/features';
import { DISABLE_REPORT_UI_REFRESH } from '../../../../../shared/featureFlags/flagNames';

const securityEnabledItems = Object.entries(ReportCategoryTitles);
const securityDisabledItems = securityEnabledItems.filter(([key]) => key !== ReportCategories.Vulnerability);

type Props = {
  baseUrl: string;
};

/**
 * ReleaseGroupSubnavItemReports is the Subnav item for the reports section of a release group.
 */
const ReleaseGroupSubnavItemReports: VoidFunctionComponent<Props> = ({
  baseUrl,
}) => {
  const isSecurityAndPDFReportsEnabled = useCanDisplaySecurityOptions();
  const isReportUIRefreshEnabled = !useIsFeatureEnabled(DISABLE_REPORT_UI_REFRESH);
  const shouldShowSettings = isReportUIRefreshEnabled && !isFreeTier(window?.user?.organization?.stripe_plan); // For settings

  const enabledProjectReportEntries = isSecurityAndPDFReportsEnabled
    ? securityEnabledItems
    : securityDisabledItems;
  return (
    <Subnav.Dropdown
      to={`${baseUrl}/reports`}
      navKey="reports"
    >
      <Subnav.Dropdown.RootItem>
        Reports
      </Subnav.Dropdown.RootItem>
      {enabledProjectReportEntries.map(([reportType, title]) => (
        <Subnav.Dropdown.Item
          key={reportType}
          to={`${baseUrl}/reports/${reportType}`}
          navKey={`reports/${reportType}`}
        >
          {title}
        </Subnav.Dropdown.Item>
      ))}
      {shouldShowSettings && (
        <Subnav.Dropdown.Item
          to={`${baseUrl}/reports/settings`}
          navKey="reports/settings"
        >
          Settings
        </Subnav.Dropdown.Item>
      )}
    </Subnav.Dropdown>
  );
};

export default ReleaseGroupSubnavItemReports;
